import React from 'react';
import { identity } from 'lodash';
import { CounterProps } from './types';

const Counter = ({ current, max, format = identity }: CounterProps) => {
  const formattedCurrent = format(current, {
    fallbackValue: current,
    noFractionDigits: true,
  });
  const formattedMax =
    max &&
    format(max, {
      fallbackValue: max,
      noFractionDigits: true,
    });
  const content = max ? `${formattedCurrent}/${formattedMax}` : formattedCurrent;

  return <>{content}</>;
};

Counter.displayName = 'Counter';

export default Counter;
